import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { TutorialWizardComponent } from '../tutorial-wizard.component';
import { TutorialWizardSlideDirective } from '../tutorial-wizard-slide.directive';
import { TutorialSlideContentComponent } from '../tutorial-slide-content/tutorial-slide-content.component';
import { TutorialVersusContentComponent } from '../tutorial-versus-content/tutorial-versus-content.component';
import { GameTutorial } from './game-tutorial';

@Component({
  selector: 'app-slots-tutorial',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TutorialWizardComponent,
    TutorialWizardSlideDirective,
    TutorialSlideContentComponent,
    TutorialVersusContentComponent,
  ],
  template: `
    <app-tutorial-wizard [totalPages]="3" [slideTitles]="slideTitles">
      <div appTutorialSlide>
        <app-tutorial-slide-content
          [imageUrl]="img('slots-tutorial-1.png')"
          [description]="t('slots-slide-1')"
        />
      </div>

      <div appTutorialSlide>
        <app-tutorial-slide-content
          [imageUrl]="img('slots-tutorial-2.png')"
          [description]="t('slots-slide-2')"
        />
      </div>

      <div appTutorialSlide>
        <app-tutorial-versus-content
          [imageUrl]="img('slots-tutorial-3.png')"
          [description]="t('slots-slide-3')"
          labelBottom="4%"
        />
      </div>
    </app-tutorial-wizard>
  `,
  styles: [],
})
export class SlotsTutorialComponent implements GameTutorial {
  private translocoService = inject(TranslocoService);
  private themeService = inject(ThemeService);

  readonly slideTitles = [this.t('how-to-play'), this.t('how-to-win'), this.t('real-opponents')];

  t(key: string): string {
    return this.translocoService.translate(`components.tutorial-wizard.${key}`);
  }

  img(name: string): string {
    return this.themeService.imageUrl(name);
  }
}
